import { render, staticRenderFns } from "./Contact-company-card.vue?vue&type=template&id=b09202b2&scoped=true&"
import script from "./Contact-company-card.vue?vue&type=script&lang=js&"
export * from "./Contact-company-card.vue?vue&type=script&lang=js&"
import style0 from "./Contact-company-card.vue?vue&type=style&index=0&id=b09202b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09202b2",
  null
  
)

export default component.exports